export default __webpack_public_path__ + "static/media/UpComingImage.dc960b94.svg";